import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import ButtonRounded from "../../global/buttons/ButtonRounded";
import ChoixTextQ3 from "../ordi/ChoixTextQ3";
import QuestionPanel from "./QuestionPanel";

export default class QuestionPanel_3 extends QuestionPanel {
    constructor(scene, x, y, {config, totQuestion}) {
        super(scene, x, y, {
            numquestion: 3,
            totQuestion,
            question: config.question,
            textIndice: config.indice
        });

        this.config = config
        this.buttons = []

        let Y = this.sousTitreText.y + this.sousTitreText.height + 24

        // Ajout question
        let questionText = this.scene.add.text(this.width/2, Y, "Cette image a été conçue avec :", {
            fontSize: "20px",
            fontFamily: FONTS.Inter18Light,
            color: Colors.Text.Black,
        }).setOrigin(0.5, 0)
        this.add(questionText)
        Y += questionText.height + 50

        // Ajout boutons reponses
        this.choiceButton = new ChoixTextQ3(this.scene, this.width/2, Y, config.reponses, ()=> {this.validateButton.setUnlocked();})

        this.add(this.choiceButton)
        Y += this.choiceButton.height + 24

        // Ajout bouton valider
        this.validateButton = new ButtonRounded(this.scene, this.width /2, this.choiceButton.y + this.choiceButton.height/2 + 24, {
            text: "Valider ma réponse",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.White,
        })
        this.add(this.validateButton)
        this.validateButton.setLocked()
        this.validateButton.y+= this.validateButton.height/2
        this.validateButton.setClickFunction( () => {
            // On bloque tous les éléments du panneau
            this.setLocked()

            // On vérifie la réponse
            const isTrue = this.choiceButton.isTrue();
            if(isTrue || this.tentative >= this.maxTentative){
                this.scene.showReponsePopUp({
                    text: config.correction,
                    isTrue: isTrue,
                    endFunc: () => {
                        this.scene.closePanelQuestion((scene) => {scene.addDebrief();});
                        this.scene.closeReponsePopUp();
                    }
                });
            }else{
                this.scene.cameras.main.shake(200, 0.01);
                this.tentative++;
                this.setUnlocked();
            }
        })
    }

    setLocked(){
        super.setLocked();
        this.choiceButton.hideButtons()
        this.validateButton.setLocked();
    }

    setUnlocked(){
        super.setUnlocked();
        this.choiceButton.showButtons()
        this.validateButton.setUnlocked();
    }
}